import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './Components/HomePage';
import AboutUs from './Components/AboutUs';
import PrivacyPolicy from './Components/PrivacyPolicy';
import Private from './Components/Private';
import FAQ from './Components/FAQ';
import Demo from './Components/Demo';
import Inferences from './Components/Inferences';
import InferencesTable from './Components/InferencesTable';
import './App.css';
import Manifesto from './Components/Manifesto';
import Pricing from './Components/Pricing';
import Portal from './Components/Portal';
import Footer from './Components/Footer';
import TermsOfService from './Components/TermsOfService';
import ForCandidates from './Components/ForCandidates';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/enterprise" element={<Private />} />
          <Route path="/manifesto" element={<Manifesto />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/schedule-demo" element={<Demo />} />
          <Route path="/inferences" element={<Inferences />} />
          <Route path="/inferences-table" element={<InferencesTable />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/private" element={<Private />} />
          <Route path="/for-companies" element={<Portal />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/for-candidates" element={<ForCandidates />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
